import React, { useState } from 'react'
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { Check as CheckIcon, X as XIcon } from 'react-feather'

import useStyles from './styles'
import useAuth from 'hooks/useAuth'

const EvidenceAnalysisDai = ({ daiResponse }) => {
  const classes = useStyles()
  const { user } = useAuth()

  const [open, setOpen] = useState(false)

  const isInternalUser =
    user?.email?.endsWith('@dponet.com.br') ||
    user?.email?.endsWith('@leavening.com')

  const formattedResponse = daiResponse?.response?.body?.formattedResponse?.data

  if (!isInternalUser) return null
  if (!formattedResponse) return null

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const { approved, justification, metRequirements } = formattedResponse

  return (
    <>
      <IconButton onClick={handleOpen}>
        {approved ? (
          <CheckIcon className={classes.checkIcon} />
        ) : (
          <XIcon className={classes.xIcon} />
        )}
      </IconButton>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent className={classes.dialogContent}>
          <Box className={classes.header}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Análise da Evidência
            </Typography>
            <Chip
              label={approved ? 'Aprovado' : 'Reprovado'}
              className={approved ? classes.approvedChip : classes.rejectedChip}
            />
          </Box>

          {justification && (
            <Box>
              <Typography variant="subtitle1" className={classes.sectionTitle}>
                Justificativa
              </Typography>
              <Typography variant="body2" className={classes.justificationText}>
                {justification}
              </Typography>
            </Box>
          )}

          {metRequirements && metRequirements.length > 0 && (
            <>
              <Divider className={classes.divider} />
              <Box>
                <Typography
                  variant="subtitle1"
                  className={classes.sectionTitle}
                >
                  Requisitos Avaliados
                </Typography>
                <List className={classes.metsList}>
                  {metRequirements.map((item, index) => (
                    <ListItem key={index} className={classes.metItem}>
                      <ListItemIcon className={classes.metIcon}>
                        {item.met ? (
                          <CheckIcon className={classes.checkIcon} size={20} />
                        ) : (
                          <XIcon className={classes.xIcon} size={20} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.requirement}
                        secondary={item.observation}
                        classes={{
                          primary: classes.metPrimary,
                          secondary: classes.metSecondary,
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default EvidenceAnalysisDai
